export const getLatestVersion = async () => {
    const randomID = Math.random()
        .toString(36)
        .substring(2, 16);

    await fetch(`https://developer.curity.io/docs/latest/_static/js/versions.js?v=${randomID}`)
        .then(response => {
            return response.text();
        })
        .then(data => {
            const latestVersion = JSON.parse(data.slice(11));
            document.querySelector(".dropdown-content-link-version").textContent = latestVersion[0];
        });
};
